module.exports = __webpack_public_path__ + "img/0020.ffe63724.png";